import {View} from 'backbone';

import _template from 'dashboard/settings/settings-main.ejs';

class SettingsMainView extends View {

    initialize(opts) {
        this.options = opts || {};
        this.template = _template;

        return this;
    }


    render() {
        this.$el.html(this.template(this.model.toJSON()));


        return this;


    }

}

export default SettingsMainView;